import {
  focusSoftphone,
  openSoftphonePopup,
  softphoneLiveCall,
} from 'components/CallScribe/popout';
import { callContextFor, type IOpenCallPopupParams } from 'components/CallScribe/popupCallContext';
import { isSameNumber } from 'components/CallScribe/softphoneLiveCall';

export interface IPopupBusy {
  busyWith: string;
  sameCall: boolean;
}

export type TOpenCallPopupResult =
  | { opened: true }
  | ({ opened: false } & IPopupBusy);

export const popupBusyMessage = ({ busyWith, sameCall }: IPopupBusy): string => {
  if (sameCall) return `You're already on a call with ${busyWith}.`;
  return busyWith
    ? `You're on a call with ${busyWith}. End it before starting another.`
    : 'You\'re on a call in another CallScribe window. End it before starting another.';
};

export const openCallPopup = (params: IOpenCallPopupParams): TOpenCallPopupResult => {
  const live = softphoneLiveCall();
  if (live) {
    focusSoftphone();
    return { opened: false, busyWith: live.callee, sameCall: isSameNumber(live.toNumber, params.to) };
  }
  openSoftphonePopup(callContextFor(params));
  return { opened: true };
};
